import { Component, Input, OnInit } from '@angular/core';

import * as Mapboxgl from 'mapbox-gl';

@Component({
  selector: 'app-school',
  templateUrl: './school.component.html',
  styleUrls: ['./school.component.scss']
})
export class SchoolComponent implements OnInit {

  schoolList = [];
  Map : Mapboxgl.Map;
  @Input() address: string
  @Input() lat: string
  @Input() lng: string

  constructor() { }

  ngOnInit() {
    this.schoolList = [
      {schoolName:'schoolA'},
      // {schoolName:'schoolB'},
      // {schoolName:'schoolC'}
    ];
  }

}
